import React, { useRef } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

import ModalContainer from '@components/modals/ModalContainer';

import Product from '@features/supplier/component/Product';
import SupplierTypeWiseMaterialList from '@features/supplier/component/SupplierTypeWiseMaterialList';

import { capitalizeFirstLetter } from '@utils/Util';

const ViewAllPopup = ({
	supplierType,
	onClose,
	productList,
	setDesignIdToView,
	callback,
	productResponse,
	renderTypeWiseTag
}) => {
	const supplierStore = useSelector((store) => store.supplierStore);
	const { id } = useParams();
	const scrollRef = useRef(null);
	const isLoading = useSelector((store) => store.loaderStore);

	const handleScroll = () => {
		const wrappedElement = scrollRef.current;
		const remainingScroll =
			wrappedElement.scrollHeight - (wrappedElement.scrollTop + wrappedElement.clientHeight);
		if (remainingScroll <= 5 && !isLoading) {
			let { totalElements, currentPage, data } = productResponse;
			if (totalElements > 0 && totalElements !== data.length) {
				callback(currentPage + 1);
			}
		}
	};

	return (
		<ModalContainer onCloseModal={onClose} className="product-view-modal">
			<div className="common-popup product-view-modal">
				<div className="common-popup-header d-flex justify-content-between">
					<div className="popup-tilte">
						<h3 className="semibold-16 mb-0">
							Key products - {capitalizeFirstLetter(supplierType)}
							<span className="gray_dark_02 regular-14 ml-2">
								{supplierType === 'GARMENTS'
									? productResponse?.totalElements
									: supplierStore?.response?.data?.length}{' '}
								Styles
							</span>
						</h3>
					</div>
					<div className="close-btn" onClick={onClose}>
						<img src={`${process.env.PUBLIC_URL}/icons/close.svg`} alt="close" />
					</div>
				</div>
				<div className="common-popup-body">
					<div className="product-category d-flex justify-content-start flex-warp">
						{renderTypeWiseTag && renderTypeWiseTag()}
					</div>
					{supplierType === 'GARMENTS' && (
						<div
							className={`${productList?.length > 0 ? 'supplier-products' : ''} scroll-y-label`}
							ref={scrollRef}
							onScroll={handleScroll}
						>
							<Product
								productList={productList}
								isPopupView={true}
								supplierId={id}
								setDesignIdToView={setDesignIdToView}
								callback={() => callback}
							/>
						</div>
					)}

					{supplierType === 'FABRIC' && (
						<SupplierTypeWiseMaterialList supplierType={supplierType} isPopupView={true} />
					)}
				</div>
			</div>
		</ModalContainer>
	);
};

export default ViewAllPopup;
